

// src/utils/api.js
import axios from "axios";

const api = axios.create({
  
//baseURL: "http://localhost:4000/api",
baseURL: process.env.REACT_APP_API_URL || "https://api.onedesk.digital/api",
  timeout: 10000,
  headers: {
    "Content-Type": "application/json",
  },
  
});

// Automatically attach JWT token to every request
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem("token");
    if (token) {
      config.headers["Authorization"] = `Bearer ${token}`;
    }
    return config;
  },
  (error) => Promise.reject(error)
);

// Smart response interceptor — handle 401 globally (optional bonus)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Token expired or invalid → logout user
      localStorage.removeItem("token");
      localStorage.removeItem("user");
      window.location.href = "/login";
    }
    return Promise.reject(error);
  }
);

export default api;